import axios from "axios"
import { VERSION } from "../config";
const _MODULE = `/mall/${VERSION}/app/user_address`;
export default {
    /***
     * 获取服务地址数据
     */
    getAddressList() {
        return axios({
            url: `${_MODULE}/list`,
            method:`GET`
        })
    },
    /***
     * 新增服务地址
     */
    addNewAddress(data) {
        return axios({
            url: `${_MODULE}`,
            method:`post`,
            data
        })
    },
    /***
     * 删除服务地址
     */
    deleteAddress(id) {
        return axios({
            url: `${_MODULE}/${id}`,
            method:`delete`,
        })
    },
    /***
     * 编辑服务地址
     */
    editAddress(data) {
        return axios({
            url: `${_MODULE}`,
            method:`put`,
            data
        })
    }
}


// WEBPACK FOOTER //
// ./src/apis/src/myAddressList.js